<template style="">
 <div  style="width: 100%; background-color:#E6F0F2;" >
  <div  style="width: 50%;margin:0 auto;min-width:730px;" >
	<div style="padding-top:30px">
		<a href="https://www.ceprei.com/index.html">
		<img src="https://www.ceprei.com/assets/img/logo1-default.png" alt="Logo"></a>
		</div>
  </div>

	<div style="width: 100%;height:60px;background-color:#DCDCDC;padding-top:3px;padding-bottom:1px;" >
		<div style="width: 100%;height:60px;background-color:#E6F0F2;"> 
			<div  style="width:50%;margin:0 auto;min-width:730px;" >
				<div style="float:left;font-size:250%;font-weight:bold;margin-top:10px">培训满意度评价表</div>
				<div style="float:right;margin-top:15px;color:#97a8be"><a href="https://www.ceprei.com/">首页</a> / 培训满意度评价表 </div>
			</div> 
		</div> 
	</div>

	<div  style="line-height:45px;width: 50%;margin:0 auto;margin-top:30px;min-width:730px;font-size:19px;;" >
		您的回答有助于我们了解此培训项目的效果，持续改进后续培训项目。感谢您填写这份问卷！<br>
		姓名：<el-input v-model="data.name" placeholder="请输入姓名" style="width:200px"></el-input>&emsp;&emsp;<br>
		电话：<el-input v-model="data.pone" placeholder="请输入电话" style="width:200px"></el-input>&emsp;&emsp;<br>
		邮箱：<el-input v-model="data.email" placeholder="请输入邮箱" style="width:200px"></el-input>&emsp;&emsp;
		<br>
	</div>
	<div style="width: 50%;margin:0 auto;margin-top:30px;min-width:730px;font-size:19px;font-weight:bold " >
		<span >1.您对此次培训效果是否满意？</span> <br> <br>&nbsp;
		<template>
			<el-radio v-model="data.radio1" label="1">非常满意</el-radio>
			<el-radio v-model="data.radio1" label="2">比较满意</el-radio>
			<el-radio v-model="data.radio1" label="3">一般满意</el-radio>
			<el-radio v-model="data.radio1" label="4">不满意</el-radio>
		</template>
	</div>
	<div style="width: 50%;margin:0 auto;margin-top:30px;min-width:730px;font-size:19px;font-weight:bold " >
		<span >2.您对培训课程内容设置是否满意？</span> <br> <br>&nbsp;
		<template>
			<el-radio v-model="data.radio2" label="1">非常满意</el-radio>
			<el-radio v-model="data.radio2" label="2">比较满意</el-radio>
			<el-radio v-model="data.radio2" label="3">一般满意</el-radio>
			<el-radio v-model="data.radio2" label="4">不满意</el-radio>
		</template>
	</div>
	<div style="width: 50%;margin:0 auto;margin-top:30px;min-width:730px;font-size:19px;font-weight:bold " >
		<span >3.您对培训课时安排是否满意？</span> <br> <br>&nbsp;
		<template>
			<el-radio v-model="data.radio3" label="1">非常满意</el-radio>
			<el-radio v-model="data.radio3" label="2">比较满意</el-radio>
			<el-radio v-model="data.radio3" label="3">一般满意</el-radio>
			<el-radio v-model="data.radio3" label="4">不满意</el-radio>
		</template>
	</div>
	<div style="width: 50%;margin:0 auto;margin-top:30px;min-width:730px;font-size:19px;font-weight:bold " >
		<span >4.您对培训教材或讲义是否满意？</span> <br> <br>&nbsp;
		<template>
			<el-radio v-model="data.radio4" label="1">非常满意</el-radio>
			<el-radio v-model="data.radio4" label="2">比较满意</el-radio>
			<el-radio v-model="data.radio4" label="3">一般满意</el-radio>
			<el-radio v-model="data.radio4" label="4">不满意</el-radio>
		</template>
	</div>
	<div style="width: 50%;margin:0 auto;margin-top:30px;min-width:730px;font-size:19px;font-weight:bold " >
		<span >5.您对授课讲师表达能力和授课技巧是否满意？</span> <br> <br>&nbsp;
		<template>
			<el-radio v-model="data.radio5" label="1">非常满意</el-radio>
			<el-radio v-model="data.radio5" label="2">比较满意</el-radio>
			<el-radio v-model="data.radio5" label="3">一般满意</el-radio>
			<el-radio v-model="data.radio5" label="4">不满意</el-radio>
		</template>
	</div>
	<div style="width: 50%;margin:0 auto;margin-top:30px;min-width:730px;font-size:19px;font-weight:bold " >
		<span >6.您对授课讲师专业水平是否满意？</span> <br> <br>&nbsp;
		<template>
			<el-radio v-model="data.radio6" label="1">非常满意</el-radio>
			<el-radio v-model="data.radio6" label="2">比较满意</el-radio>
			<el-radio v-model="data.radio6" label="3">一般满意</el-radio>
			<el-radio v-model="data.radio6" label="4">不满意</el-radio>
		</template>
	</div>
	<div style="width: 50%;margin:0 auto;margin-top:30px;min-width:730px;font-size:19px;font-weight:bold " >
		<span >7.您对此次培训的会务工作是否满意？</span> <br> <br>&nbsp;
		<template>
			<el-radio v-model="data.radio7" label="1">非常满意</el-radio>
			<el-radio v-model="data.radio7" label="2">比较满意</el-radio>
			<el-radio v-model="data.radio7" label="3">一般满意</el-radio>
			<el-radio v-model="data.radio7" label="4">不满意</el-radio>
		</template>
	</div>
	<div style="width: 50%;margin:0 auto;margin-top:30px;min-width:730px;font-size:19px;font-weight:bold " >
		<span >8.您对本次培训的整体评价是否满意？</span> <br> <br>&nbsp;
		<template>
			<el-radio v-model="data.radio8" label="1">非常满意</el-radio>
			<el-radio v-model="data.radio8" label="2">比较满意</el-radio>
			<el-radio v-model="data.radio8" label="3">一般满意</el-radio>
			<el-radio v-model="data.radio8" label="4">不满意</el-radio>
		</template>
	</div>
	<div style="width: 50%;margin:0 auto;margin-top:30px;min-width:730px;font-size:19px;font-weight:bold " >
		<span >9.您对本次的培训是否还有其他的改进建议？</span> <br> &nbsp;
		 <div style="width:70%; ;">
             <el-input maxlength="3800" show-word-limit  type="textarea" v-model="data.suggest" :autosize="{ minRows: 3, maxRows: 3}" > </el-input>
        </div>
	</div>
	<div style="width: 50%;margin:0 auto;margin-top:30px;min-width:730px;font-size:19px;font-weight:bold " >
		<span >10.您还有需要参加哪些方面的培训？</span> <br> &nbsp;
		 <div style="width:70%; ;">
             <el-input maxlength="3800" show-word-limit  type="textarea" v-model="data.need" :autosize="{ minRows: 3, maxRows: 3}" > </el-input>
        </div>
	</div>
	<div style="width: 50%;margin:0 auto;margin-top:30px;min-width:730px;font-size:19px;font-weight:bold " >
		<el-button  type="primary" @click="saveDiaoCha();">&emsp;提交意见&emsp;</el-button>
		 
	</div>
  
	<br>&nbsp;<br>&nbsp;<br>&nbsp;<br>&nbsp;<br>&nbsp;<br>&nbsp;<br>&nbsp;	<br>&nbsp;<br>&nbsp;<br>&nbsp;
  <div style="position:fixed;   bottom:0;  z-index:999;width:100%;    background-color: #3e4753;   color:rgb(218, 213, 213) ;  font-size: 14px " >
		<div style="width: 50%;margin:0 auto;padding-top:10px;min-width:730px">
				<div style="float: right;" ><a href="https://www.ceprei.com/index.html" ><img src="https://ca.ceprei.com/_nuxt/img/logo2-default.73cb0f3.png" ></a>  </div>
				<p >Copyright © 2015. 中国赛宝实验室 All rights reserved. &nbsp;<i class="icon-home" ></i>&nbsp;广州市增城区朱村街朱村大道西78号 &nbsp;粤ICP备09030372号</p>
				<p >网站维护：020-87237193 业务联系：020-87236881</p>
		</div>
  </div>					
</div>
</template>
 <script>
import { RequestGet, RequestPost, url } from '../../api/api'
 

  export default {
    data() {
       return {
		errResult:'', 
		reportCodeSeach:'',
		checkCodeSeach:'',
		seachShow:true,
		data:{
			pxId:'',
			name:'秦亚军',
			email:'792399923@qq.com',
			pone:'18102801535',
			radio1:'1',
			radio2:'1',
			radio3:'1',
			radio4:'1',
			radio5:'1',
			radio6:'1',
			radio7:'1',
			radio8:'1',
			 
			suggest:'建议1',
			need:'需求2'
		},
      };
    },
    created:function(){
		 document.title = '中国赛宝官方网站-培训满意度评价表';
		 this.data.pxId = this.$route.query.pxId
		 			
    },
    methods: {
		
		saveDiaoCha() {
			let msg = this.verify(this.data)
			if(msg!==null){
				this.$message({  type: 'error',  message: msg  });  
				return
			}
			RequestPost("/weixin/saveDiaoCha",this.data).then(response => {
					if(response['data']==''||response['data']==undefined){
						this.$alert("提交成功,感谢您的意见", '提示',{dangerouslyUseHTMLString: true,lockScroll:false})
						return;
					}
				}).catch(error => {
					this.resultShow=false;
					this.seachShow=true;
					this.$alert('请求失败,请联系相关业务人员', '请求错误',{lockScroll:false})
				})
		},
	
	
		verify(data){
			if(data.name===''){
				return '请填写名字';
			}
			if(data.email==''){
				return '请填写邮箱';
			}
			if(data.pone==''){
				return '请填写手机号码';
			}
			if(data.radio1===''){
				return '请选择选项1';
			}
			if(data.radio2===''){
				return '请选择选项2';
			}
			if(data.radio3===''){
				return '请选择选项3';
			}
			if(data.radio4===''){
				return '请选择选项4';
			}
			if(data.radio5===''){
				return '请选择选项5';
			}
			if(data.radio6===''){
				return '请选择选项6';
			}
			if(data.radio7===''){
				return '请选择选项7';
			}
			if(data.radio8===''){
				return '请选择选项8';
			}
			 
			return null;
		},
	},
		
  }
</script>
 


// WEBPACK FOOTER //
// questionnaire.vue?211495b5